/* global tracker, FB */

import 'html/include/js/om/om';
import 'html/include/js/zepto.min';
import 'html/include/js/jquery.unveil';
import 'html/include/js/zepto-anim.min';
import '@html/_common/script_es6';

import {
  byUserInteraction,
  byWindowAction,
  debounce,
  disableBodyScrollLock,
  enableBodyScrollLock,
  exposeDepartureCardsExperiment,
  exposeTDPNavigationExperiment,
  getBreakpointMinWidth,
  getCookie,
  handleMagnificPopupHistory,
  initiateFallbackBackgroundImages,
  isElementOnScreen,
  libInit,
  loadJs,
  parameters,
  sendAmplitudeEvent,
  sendGoogleEvent,
  sendRequest,
  smoothScroll,
  exposeStructuredItineraryExperiment,
  formatNumberLocale,
} from '@html/_common/utils';

import AOTourBrochure from '@atomic/organisms/tour_b/brochure';
import AdminQuestions from '@html/_common/admin_questions';
import DynamicMap from '@html/dynamicmap_b/script';
import HeroImageGallery from '@atomic/organisms/tour_b/snapshot/hero-image';
import HeroImageGalleryGrid from '@atomic/organisms/tour_b/snapshot/hero-image-gallery/hero-image-gallery';
import AoTourStickyBar from '@atomic/organisms/tour_b/sticky-bar/sticky-bar';
import ReviewsSection from '@atomic/organisms/tour_b/reviews/script';
import initiateAnimalsYouWillSee from '@atomic/organisms/tour_b/animals-you-will-see';
import initiateAwards from '@atomic/organisms/tour_b/awards';
import initiateStartPlanningYourTour from '@atomic/organisms/tour_b/start-planning-your-tour';
import initiatePlacesYouWillSee from '@atomic/organisms/tour_b/places-you-will-see';
import initiateAdventureType from '@atomic/organisms/tour_b/adventure-type';
import initiateAskForm from '@atomic/organisms/tour_b/ask-form-content';
import AOFaqSearch from '@atomic/organisms/tour_b/faq-search';
import AOThreadedFaqs from '@atomic/organisms/tour_b/threaded-faqs';
import initiateAskQuestion from '@atomic/organisms/tour_b/shared/js/ask-question';
import initiateBottomBanner from '@atomic/organisms/tour_b/bottom-banner';
import initiateWhereStay from '@atomic/organisms/tour_b/where-stay';
import initiateCustomerPhotos from '@atomic/organisms/tour_b/customer-photos/customer-photos';
import AOWhatsIncluded from '@atomic/organisms/tour_b/whats-included';
import initiateBookFlexibilityBanner from '@atomic/organisms/tour_b/book-flexibility-banner';
import initiateVideos from '@atomic/organisms/tour_b/videos';
import AOVisa from '@atomic/molecules/tour_b/visa';
import AOPdfDownload from '@atomic/molecules/tour_b/pdf';
import AOItinerary from '@atomic/organisms/tour_b/itinerary';
import AOTourFlexibleOptionsPopup from '@atomic/organisms/tour_b/flexibility/flexible-options-card';
import AOSustainabiltyPopup from '@atomic/organisms/tour_b/sustainability/sustainability';
import AOTourAboveFold from '@atomic/organisms/tour_b/snapshot/above-fold';
import AOTourTravelAgentLoginPrompt
  from '@atomic/organisms/_common/travel_agent/travel-agent-login-prompt';
import AOTourTravelAgentShareTour
  from '@atomic/organisms/_common/travel_agent/travel-agent-share-tour-popup';
import AOTravelAgentContactForm
  from '@atomic/organisms/_common/travel_agent/travel-agent-contact-form';
import AOScoutNewsletterSignupForm
  from '@scout/components/newsletter-signup-form/newsletter-signup-form';
import Timer from '@html/_utils/timer';
import setupMapImageBlock from '@atomic/organisms/tour_b/map-image-block';
import AvailabilitySection from '@atomic/organisms/tour_b/availability';
import AOTourPrivateOptionRequest from '@atomic/organisms/tour_b/private-request/private-request';
import LiveChat from '@html/_modules/live-chat';
import NavigationTabs from '@atomic/organisms/tour_b/navigation-tabs/navigation-tabs';
import AOPaxTravelers
  from '@atomic/organisms/_common/pax-selector/travelers/pax-travelers';
import AOPaxMonth from '@atomic/organisms/_common/pax-selector/month/pax-month';
import AOPaxTravelersMenu from '@atomic/organisms/_common/pax-selector/travelers/menu/pax-travelers-menu';
import AOPaxMonthMenu from '@atomic/organisms/_common/pax-selector/month/menu/pax-month-menu';
import StickyMenu from '@scout/components/sticky-menu/index';
import AOStructuredItinerary from '@atomic/organisms/tour_b/structured-itinerary/structured-itinerary';

export default function Tour() {
  const TDP_EVENT_CATEGORY = 'Tour Detail';
  const CHECK_AVAILABILITY_ACTION = 'Check Availability';
  const TABLET_WIDTH = getBreakpointMinWidth('m2') - 1;
  const MOBILE_WIDTH = getBreakpointMinWidth('m1') - 1;

  const adminQuestions = new AdminQuestions();

  const HYGIENE_HASH = 'hygiene-measures';

  const ACCORDION_LIST_SELECTOR = '.js-ao-tour-good-to-know .js-ao-common-accordion';
  const CHECK_AVAILABILITY_BUTTON_SELECTOR = '.js-ao-tour__booking-intent';
  const NO_DEPARTURES_NEWSLETTER_SELECTOR = '.js-ao-tour-no-departure-block__form-wrapper';
  const PDF_BROCHURE_DOWNLOAD_BUTTON_SELECTOR = '.js-ao-tour-start-planning-your-tour__cta-brochure';
  const CHECK_AVAILABILITY_PAX_BUTTON_SELECTOR = '.js-ao-tour__booking-intent-pax';
  const VARIANTS_CONTAINER_SELECTOR = '.js-ao-tour-availability__variants-container';
  const VARIANTS_CONTAINER_LOAD_CLASS = 'ao-tour-availability__variants-container--loading';
  const OTHER_DEPARTURE_SELECTOR = '.js-am-tour-availability-other-departures';
  const VARIANT_SELECTOR = '.js-am-tour-availability__variant';
  const SHOW_MORE_UPCOMING_DATES_BUTTON = '.js-ao-tour-availability__variants-show-more';
  const SHOW_MORE_PAX_AVAILABILITY_BUTTON = '.js-ao-tour-availability__variants-show-more-pax';

  this.timerStart = Date.now();
  this.scrollElementList = [];
  this.scrollPos = 0;
  this.availabilitySection = false;
  this.imageGalleryLightboxManager = false;
  this.paxAvailabilityPage = 1;
  this.initialClickedElement = '';
  this.initialClickedImageCount = null;
  this.fullItineraryPopup = null;

  // used for checking if map popup overlays page as page scrolls in background as well
  this.mapPopupEventElements = [
    'Scroll to End of Map Destinations',
    'Scroll to Top of Map Nav links',
    'Scroll to End of Map Nav links',
  ];

  this.$main = $('main');

  // Track first clicked gallery item on the page
  $(document).on('click', '.js-ao-tour-hero-image-gallery-item', (event) => {
    if (!this.initialClickedElement) {
      const $clickedElement = $(event.currentTarget);
      this.initialClickedElement = event.target;
      this.initialClickedImageCount = $clickedElement.data('image-count');
      $('.js-ao-tour-hero-image-gallery-wrapper-overlay')?.removeClass('hid');

      // If gallery grid is already initialized, trigger the modal opening
      if (this.heroImageGalleryGrid && this.heroImageGalleryGrid.openImageOnIndex) {
        this.heroImageGalleryGrid.openImageOnIndex(this.initialClickedImageCount);
      }
    }
  });

  this.getTourId = () => {
    if (typeof this.tourId === 'undefined') {
      this.tourId = this.$main.attr('data-id');
    }

    return this.tourId;
  };

  this.getTourName = () => {
    if (typeof this.tourName === 'undefined') {
      this.tourName = $('main h1').html().trim();
    }

    return this.tourName;
  };

  this.getOperatorId = () => {
    if (typeof this.operatorId === 'undefined') {
      this.operatorId = this.$main.attr('data-op');
    }

    return this.operatorId;
  };

  this.getOperatorName = () => {
    if (typeof this.operatorName === 'undefined') {
      this.operatorName = this.$main.data('op-name');
    }

    return this.operatorName;
  };

  this.getNetRevenue = () => {
    if (typeof this.netRevenue === 'undefined') {
      this.netRevenue = this.$main.attr('data-net-revenue');
    }

    return this.netRevenue;
  };

  this.getSaving = () => {
    if (typeof this.tourSaving === 'undefined') {
      this.tourSaving = this.$main.attr('data-value');
    }

    return this.tourSaving;
  };

  this.isPrivate = () => this.$main.attr('data-private');

  this.hasPrivateOrPersonalizedOption = () => this.$main.attr('data-private-option');

  this.initiateCustomerPhotos = () => {
    initiateCustomerPhotos(
      TDP_EVENT_CATEGORY,
      this.imageGalleryLightboxManager,
    );
  };

  this.initiateNavigationTabs = () => {
    const navigationTabs = new NavigationTabs(this.hash);

    navigationTabs.initiate();
  };

  this.initiateFullItineraryModalClickHandlers = (tourId) => {
    $('.js-ao-tour-itinerary__view-full, .js-ao-tour-map-image-block').on('click', (e) => {
      $('.js-ao-tour-itinerary__overlay').removeClass('hid');
      if (!this.fullItineraryPopup) {
        import(/* webpackChunkName: "FullItineraryPopup" */'@atomic/organisms/tour_b/itinerary-full/itinerary-full-popup').then((module) => {
          const AOFullItineraryPopup = module.default;
          this.fullItineraryPopup = new AOFullItineraryPopup(tourId);
          this.fullItineraryPopup.loadPopup();
        });
      } else {
        this.fullItineraryPopup.loadPopup();
      }

      const isItineraryFull = $(e.currentTarget).hasClass('js-ao-tour-itinerary__view-full');

      sendAmplitudeEvent({
        ampEventName: 'tdp_itinerary_modal_clicked',
        tdp_itinerary_modal_clicked_element: 'Open Itinerary Popup',
        itinerary_modal_source: isItineraryFull ? 'View Full Itinerary' : 'Map CTA',
      });
    });
  };

  this.initiateItineraryModalFromStructuredItinerary = (tourId) => {
    $('.js-ao-tour-structured-itinerary__map, .js-ao-tour-structured-itinerary__map-button, .js-ao-tour-structured-itinerary__info-view, .js-ao-tour-structured-itinerary__day-view-day').on('click', (e) => {
      e.stopPropagation();
      e.preventDefault();

      const indexToOpenAt = $(e.currentTarget).data('itinerary');
      $('.js-ao-tour-structured-itinerary__overlay').removeClass('hid');
      if (!this.fullItineraryPopup) {
        import(/* webpackChunkName: "FullItineraryPopup" */'@atomic/organisms/tour_b/itinerary-full/itinerary-full-popup').then((module) => {
          const AOFullItineraryPopup = module.default;
          this.fullItineraryPopup = new AOFullItineraryPopup(tourId);
          this.fullItineraryPopup.loadPopup(indexToOpenAt);
        });
      } else {
        this.fullItineraryPopup.loadPopup(indexToOpenAt);
      }

      if ($(e.currentTarget).hasClass('js-ao-tour-structured-itinerary__map') || $(e.currentTarget).hasClass('js-ao-tour-structured-itinerary__map-button')) {
        setTimeout(() => {
          sendAmplitudeEvent({
            ampEventName: 'tdp_map_clicked',
            tdp_map_clicked_modal: 'Open Map - TDP',
          });
          sendAmplitudeEvent({
            ampEventName: 'tdp_itinerary_modal_clicked',
            tdp_itinerary_modal_clicked_element: 'Open Itinerary Popup',
            itinerary_modal_source: 'Map CTA',
          });
        }, 0);
      } else if (indexToOpenAt === 0) {
        setTimeout(() => {
          sendAmplitudeEvent({
            ampEventName: 'tdp_itinerary_modal_clicked',
            tdp_itinerary_modal_clicked_element: 'Open Itinerary Popup',
            itinerary_modal_source: 'View Full Itinerary',
          });
        }, 0);
      } else {
        setTimeout(() => {
          sendAmplitudeEvent({
            ampEventName: 'tdp_itinerary_modal_clicked',
            tdp_itinerary_modal_clicked_element: 'Open Itinerary Popup',
            itinerary_modal_source: 'View day',
          });
        }, 0);
      }
    });
  };

  this.addInstalmentMessageToTourVariant = () => {
    const variantIds = [];
    const operatorId = $('main').attr('data-op');

    // We get the variants that are first loaded in the TDP
    // eslint-disable-next-line func-names
    $('.js-ao-tour-availability__variants-container').each(function () {
      // eslint-disable-next-line func-names
      $(this).find('[data-variant-id]').each(function () {
        const variantId = $(this).data('variant-id');
        if (variantId === undefined) return;
        variantIds.push(variantId);
      });
    });

    // Send request to the API with the collected variant IDs
    // and insert instalment string when necessary
    if (variantIds.length === 0) return;
    sendRequest('/api/tours/variants/instalments', {
      variant_ids: variantIds.reduce((acc, value) => {
        if (!acc.includes(value)) acc.push(value);
        return acc;
      }, []),
      operator_id: operatorId,
    }, (data) => {
      if (data && data.variants) {
        data.variants.forEach((variant) => {
          const button = document.querySelector(`button[data-variant-id="${variant}"]`);
          const parentDiv = button?.parentElement;
          const container = parentDiv?.parentElement;
          const targetDiv = container?.querySelector('.js-instalment-first-load');
          if (data && data.tagText) {
            targetDiv?.insertAdjacentHTML('beforeend', data.tagText);

            // Reset the retry counter before attempting initialization
            this.accordionRetryCount = 0;
            // Wait for DOM to update
            setTimeout(() => this.initializeAllInstallmentAccordions(), 50);
          }
        });
      }
    });
  };

  // Method to find and initialize all payment plan accordions on the page
  this.initializeAllInstallmentAccordions = () => {
    const allAccordions = document.querySelectorAll('.js-am-tour-availability__variant-installments-accordion');

    if (allAccordions.length > 0) {
      // Apply our direct fix which we know works
      this.directlyFixInstallmentAccordions(allAccordions);
      return true; // Successfully found and initialized accordions
    }

    // Check if we have a retry count stored on the instance
    if (!this.accordionRetryCount) {
      this.accordionRetryCount = 0;
    }

    // Increment the retry count
    this.accordionRetryCount += 1;

    // Only retry up to 5 times to prevent infinite loops
    if (this.accordionRetryCount < 5) {
      setTimeout(() => this.initializeAllInstallmentAccordions(), 200);
      return false;
    }

    // Reset count for future attempts
    this.accordionRetryCount = 0;
    return false;
  };

  // Direct fix method for installment accordions
  this.directlyFixInstallmentAccordions = (accordions) => {
    Array.from(accordions).forEach((accordion) => {
      // Find the clickable header
      const header = accordion.querySelector('.js-ao-common-accordion__content-top')
        || accordion.querySelector('.js-ao-common-accordion__title');

      if (!header) {
        return;
      }

      // Find the content section
      const bottom = accordion.querySelector('.js-ao-common-accordion__bottom');
      const content = accordion.querySelector('.js-ao-common-accordion__bottom-content');

      if (!bottom || !content) {
        return;
      }

      // Check if handler already attached
      if (header.hasAttribute('data-accordion-handler-attached')) {
        return;
      }

      // Mark header as having handler attached
      header.setAttribute('data-accordion-handler-attached', 'true');

      // Remove any existing click handlers by cloning
      const newHeader = header.cloneNode(true);
      header.parentNode.replaceChild(newHeader, header);

      // Add our click handler
      newHeader.addEventListener('click', (e) => {
        e.stopPropagation();

        // Toggle transition class
        accordion.classList.add('js-ao-common-accordion--transition');

        // Toggle the active state on the parent content element
        const contentElement = newHeader.closest('.js-ao-common-accordion__content')
          || newHeader.parentElement;
        if (contentElement) {
          contentElement.classList.toggle('ao-common-accordion--active');
        }

        // Toggle expanded/collapsed state
        const isExpanded = accordion.classList.contains('ao-common-accordion--expanded');

        if (isExpanded) {
          // Collapse
          bottom.style.maxHeight = '0px';
          accordion.classList.remove('ao-common-accordion--expanded');
          accordion.classList.add('ao-common-accordion--collapsed');
          accordion.classList.add('js-ao-common-accordion--collapsed');
        } else {
          // Expand
          const height = content.offsetHeight;
          bottom.style.maxHeight = `${height}px`;
          accordion.classList.add('ao-common-accordion--expanded');
          accordion.classList.remove('ao-common-accordion--collapsed');
          accordion.classList.remove('js-ao-common-accordion--collapsed');
        }

        // Remove transition class after animation completes
        setTimeout(() => {
          accordion.classList.remove('js-ao-common-accordion--transition');
        }, 300);
      });
    });
  };

  const updateBNPPath = (adults, children) => {
    $('.js-am-tour-availability__variant-cta--book').each(function () {
      const $component = $(this);
      const dataParameter = $component.attr('data-parameter') || '';

      const params = new URLSearchParams(dataParameter);

      if (adults > 0) {
        if (!params.has('travellers[1]')) {
          params.append('travellers[1]', adults);
        } else {
          params.set('travellers[1]', adults);
        }
      }

      if (children > 0) {
        if (!params.has('travellers[2]')) {
          params.append('travellers[2]', children);
        } else {
          params.set('travellers[2]', children);
        }
      } else if (params.has('travellers[2]')) {
        params.delete('travellers[2]');
      }

      $component.attr('data-parameter', params.toString());
    });
  };

  const checkPaxCookies = () => {
    const $specificPaxTravelers = $('.js-ao-pax-travelers')
      .first();

    if ($specificPaxTravelers.length) {
      const adultsCookie = document.cookie.split('; ')
        .find((row) => row.startsWith('pax_number_of_adults='));
      const childrenCookie = document.cookie.split('; ')
        .find((row) => row.startsWith('pax_number_of_children='));

      const numberOfAdults = adultsCookie && !Number.isNaN(adultsCookie.split('=')[1]) ? parseInt(adultsCookie.split('=')[1], 10) : null;
      const numberOfChildren = childrenCookie && !Number.isNaN(childrenCookie.split('=')[1]) ? parseInt(childrenCookie.split('=')[1], 10) : null;

      const numAdults = numberOfAdults || 2;
      const numChildren = numberOfChildren || 0;

      updateBNPPath(numAdults, numChildren);
    }
  };

  const checkBNPPath = () => {
    const $specificPaxTravelers = $('.js-ao-pax-travelers').first();

    if ($specificPaxTravelers.length) {
      const adults = parseInt($specificPaxTravelers.attr('data-pax-adults'), 10) || 0;
      const children = parseInt($specificPaxTravelers.attr('data-pax-children'), 10) || 0;

      updateBNPPath(adults, children);
    }
  };

  const startLoading = () => {
    // Show loading state and parent container
    $('.js-ao-tour-above-fold__price-based').removeClass('hid');
    $('.js-ao-tour-above-fold__price-based-loading').removeClass('hid');
    $('.ao-tour-above-fold__price-based-description').addClass('hid');

    // Show main price loader and hide main price wrapper
    $('.ao-tour-above-fold__main-price-loader').removeClass('hid');
    $('.ao-tour-above-fold__main-price__wrapper').addClass('hid');

    // Start loading animation
    let activeDotIndex = 0;
    const loadingInterval = setInterval(() => {
      // For each main price loader container
      $('.ao-tour-above-fold__main-price-loader').each(function () {
        const $loader = $(this);
        const $dots = $loader.find('.ao-tour-above-fold__main-price-loader-dot');
        const totalDots = $dots.length;

        // Remove active class from all dots within this loader
        $dots.removeClass('ao-tour-above-fold__main-price-loader-dot--active');

        // Add active class to current dot within this loader
        $dots.eq(activeDotIndex % totalDots).addClass('ao-tour-above-fold__main-price-loader-dot--active');
      });

      // Move to next dot
      activeDotIndex = (activeDotIndex + 1) % $('.ao-tour-above-fold__main-price-loader').first().find('.ao-tour-above-fold__main-price-loader-dot').length;
    }, 300); // Change dot every 300ms

    return loadingInterval;
  };

  const stopLoading = (loadingInterval) => {
    // Clear loading animation
    clearInterval(loadingInterval);

    // Hide loading state
    $('.js-ao-tour-above-fold__price-based-loading').addClass('hid');

    // Hide main price loader and show main price wrapper
    $('.ao-tour-above-fold__main-price-loader').addClass('hid');
    $('.ao-tour-above-fold__main-price__wrapper').removeClass('hid');
  };

  const stopLoadingOnError = (loadingInterval) => {
    // Clear loading animation
    clearInterval(loadingInterval);

    // Hide loading state
    $('.js-ao-tour-above-fold__price-based-loading').addClass('hid');

    // Hide main price loader and show main price wrapper
    $('.ao-tour-above-fold__main-price-loader').addClass('hid');
    $('.ao-tour-above-fold__main-price__wrapper').removeClass('hid');

    // Hide price-based container on error
    $('.js-ao-tour-above-fold__price-based').addClass('hid');
  };

  const fetchPriceBoxData = (month, year, adults, children) => {
    if (!month || !year) return;

    const pageId = $('main').attr('data-id');
    const dateKey = `${year}-${month.toString().padStart(2, '0')}-01`;
    const childrenParam = children ? `&children=${children}` : '';

    // Start loading
    const loadingInterval = startLoading();

    sendRequest(
      `/api/tdp/best-price/month-price/${pageId}?departure_date=${dateKey}&adults=${adults}${childrenParam}`,
      null,
      (data) => {
        // Stop loading on success
        stopLoading(loadingInterval);

        if (data) {
          // Calculate discount percentage
          const originalPrice = parseFloat(data.price);
          const finalPrice = parseFloat(data.final_price);
          const discountPercentage = originalPrice > 0
            ? Math.round(((originalPrice - finalPrice) / originalPrice) * 100)
            : 0;
          // Format prices
          const formatPrice = (price) => {
            const numericPrice = formatNumberLocale(price, {
              minimumFractionDigits: 0,
              maximumFractionDigits: 0,
            });

            return `${data.currency_symbol}${numericPrice}`;
          };

          const formatPriceNumber = (price) => {
            const numericPrice = formatNumberLocale(price, {
              minimumFractionDigits: 0,
              maximumFractionDigits: 0,
            });
            return numericPrice;
          };

          // Update currency symbol
          $('.ao-tour-above-fold__currency').text(data.currency_symbol);

          // Update price display based on discount
          if (discountPercentage > 0) {
            // Show discount elements
            $('.ao-tour-above-fold__old-price').removeClass('hid').text(`${data.currency_symbol}${formatPriceNumber(data.price)}`);
            $('.ao-tour-above-fold__price-discount').removeClass('hid').text(`-${discountPercentage}%`);
            $('.ao-tour-above-fold__price').text(formatPriceNumber(data.final_price));
          } else {
            // Hide discount elements and show only regular price
            $('.ao-tour-above-fold__old-price').addClass('hid');
            $('.ao-tour-above-fold__price-discount').addClass('hid');
            $('.ao-tour-above-fold__price').text(formatPriceNumber(data.final_price));
          }

          // Handle local payments
          if (data.local_payment && Array.isArray(data.local_payment) && data.local_payment.length > 0) {
            const localPaymentTexts = data.local_payment.map((payment) => `+ ${formatPrice(payment.cost, data.currency)} ${payment.name}`).join('\n');

            $('.ao-tour-above-fold__local-upfront').removeClass('hid').text(localPaymentTexts);
          } else {
            $('.ao-tour-above-fold__local-upfront').addClass('hid');
          }

          // Handle accommodation type description
          if (data.accommodation_type) {
            // Hide all accommodation type descriptions first
            $('.js-ao-tour-above-fold__price-based-description').addClass('hid');

            // Show the specific accommodation type description only if total travelers <= 3
            const totalTravelers = parseInt(adults, 10) + parseInt(children || 0, 10);
            if (totalTravelers <= 3 && !(parseInt(adults, 10) === 1 && parseInt(children || 0, 10) === 1)) {
              $(`.js-ao-tour-above-fold__price-based-description-${data.accommodation_type}`).removeClass('hid');
            } else {
              // Hide the parent container when description is hidden
              $('.js-ao-tour-above-fold__price-based').addClass('hid');
            }
          } else {
            // Hide all accommodation type descriptions if no accommodation_type
            $('.js-ao-tour-above-fold__price-based-description').addClass('hid');
            // Hide the parent container when no accommodation_type
            $('.js-ao-tour-above-fold__price-based').addClass('hid');
          }
        }
      },
      { type: 'GET' },
      () => {
        // Stop loading on error
        stopLoadingOnError(loadingInterval);
      },
    );
  };

  const fetchPaxAvailability = (month, year, adults, children) => {
    if (month && year) {
      const pageId = $('main').attr('data-id');
      const formattedMonth = `${month.toString().padStart(2, '0')}-${year}`;
      const childrenCount = children || 0;

      const data = {
        action: 'more_variants',
        page: this.paxAvailabilityPage,
        id: pageId,
        month: formattedMonth,
        adults,
        children: childrenCount,
        haveTransport: 0,
        transport_id: 0,
      };

      $(VARIANTS_CONTAINER_SELECTOR).addClass(VARIANTS_CONTAINER_LOAD_CLASS);
      $(SHOW_MORE_UPCOMING_DATES_BUTTON).addClass('hid');

      sendRequest(
        '/api/tour/load',
        data,
        (response) => {
          if (response && response.status === 'OK') {
            $(VARIANTS_CONTAINER_SELECTOR).removeClass(VARIANTS_CONTAINER_LOAD_CLASS);

            if (this.paxAvailabilityPage === 1) {
              $(VARIANTS_CONTAINER_SELECTOR).find(VARIANT_SELECTOR).remove();
              $(VARIANTS_CONTAINER_SELECTOR).find(OTHER_DEPARTURE_SELECTOR).remove();
            }

            if (response.html) {
              $(VARIANTS_CONTAINER_SELECTOR).append(response.html);
              checkBNPPath();

              if (response.less === 0) {
                $(SHOW_MORE_PAX_AVAILABILITY_BUTTON).addClass('hid');
              } else {
                $(SHOW_MORE_PAX_AVAILABILITY_BUTTON).removeClass('hid');
              }
            }
          }
        },
      );
    }
  };

  this.initiatePaxSelector = () => {
    const stickyMenuTravelers = new StickyMenu({ selector: '.js-ao-pax-travelers-sheet' });
    stickyMenuTravelers.initiateWithoutOpening();

    const stickyMenuMonth = new StickyMenu({ selector: '.js-ao-pax-month-sheet' });
    stickyMenuMonth.initiateWithoutOpening();

    const paxTravelers = new AOPaxTravelers(stickyMenuTravelers);
    paxTravelers.initiate();

    const paxMonth = new AOPaxMonth(stickyMenuMonth);
    paxMonth.initiate();

    const paxTravelersMenu = new AOPaxTravelersMenu(true);
    paxTravelersMenu.initiate();

    const paxMonthMenu = new AOPaxMonthMenu(true);
    paxMonthMenu.initiate();

    $(document).on('paxSelection:monthChange paxSelection:travelersChange', (event, eventData) => {
      // Use event data directly to ensure we have the most recent values
      // (DOM updates are deferred to requestAnimationFrame, so reading from DOM would give stale data)
      let month;
      let year;
      let adults;
      let children;

      // Get fresh data from event payload or fallback to DOM
      if (eventData) {
        // paxSelection:monthChange provides { month, year }
        // paxSelection:travelersChange provides { numberOfAdults, numberOfChildren }
        month = eventData.month;
        year = eventData.year;
        adults = eventData.numberOfAdults;
        children = eventData.numberOfChildren;
      }

      // Fallback to DOM for any missing values (backward compatibility)
      const paxData = this.getPaxData();
      const finalMonth = month || paxData.month;
      const finalYear = year || paxData.year;
      const finalAdults = adults !== undefined ? adults : paxData.adults;
      const finalChildren = children !== undefined ? children : paxData.children;

      if (!finalMonth || !finalYear) return;

      // Defer API calls to next frame to improve INP
      // This allows visual feedback to render first before heavy network operations
      requestAnimationFrame(() => {
        fetchPriceBoxData(finalMonth, finalYear, finalAdults, finalChildren);
        fetchPaxAvailability(finalMonth, finalYear, finalAdults, finalChildren);
      });
    });
  };

  const updatePricesBasedOnPaxCookies = () => {
    const $specificPaxTravelers = $('.js-ao-pax-travelers')
      .first();

    if ($specificPaxTravelers.length) {
      const now = new Date();
      const currentYear = now.getFullYear();
      const currentMonth = now.getMonth() + 1;

      const monthYearCookie = document.cookie.split('; ').find((row) => row.startsWith('pax_month_year='));
      if (monthYearCookie) {
        const [month, year] = monthYearCookie.split('=')[1].split('-');
        const parsedYear = Number.isNaN(parseInt(year, 10)) ? null : parseInt(year, 10);
        const parsedMonth = Number.isNaN(parseInt(month, 10)) ? null : parseInt(month, 10);

        // Check if the month is a past month
        if (parsedYear === null
          || parsedMonth === null
          || parsedYear < currentYear
          || (parsedYear === currentYear && parsedMonth < currentMonth)) {
          return;
        }

        const adultsCookie = document.cookie.split('; ')
          .find((row) => row.startsWith('pax_number_of_adults='));
        const childrenCookie = document.cookie.split('; ')
          .find((row) => row.startsWith('pax_number_of_children='));

        const numberOfAdults = adultsCookie && !Number.isNaN(adultsCookie.split('=')[1]) ? parseInt(adultsCookie.split('=')[1], 10) : null;
        const numberOfChildren = childrenCookie && !Number.isNaN(childrenCookie.split('=')[1]) ? parseInt(childrenCookie.split('=')[1], 10) : null;

        const numAdults = numberOfAdults || 2;
        const numChildren = numberOfChildren || 0;

        this.paxAvailabilityPage = 1;

        fetchPriceBoxData(month, year, numAdults, numChildren);
        fetchPaxAvailability(month, year, numAdults, numChildren);
      }
    }
  };

  this.initiate = () => {
    byUserInteraction('add-instalment-message-to-variants', this.addInstalmentMessageToTourVariant.bind(this));

    const tourId = this.getTourId();

    this.processScroll();

    this.eventsInit();

    this.initiateAvailabilitySection();

    this.initiateNavigationTabs();

    this.initiatePaxSelector();

    updatePricesBasedOnPaxCookies();

    if (document.getElementById('ao-tour-structured-itinerary')) {
      this.initiateItineraryModalFromStructuredItinerary(tourId);
    } else {
      this.initiateFullItineraryModalClickHandlers(tourId);
    }

    // Customer Photos, Hero Image and Reviews
    byUserInteraction('initiate-lightbox-manager', () => {
      import(/* webpackChunkName: "ImageGalleryLightboxManager" */'@atomic/organisms/tour_b/image-gallery-lightbox-manager').then((module) => {
        const ImageGalleryLightboxManager = module.default;
        if (!this.imageGalleryLightboxManager) {
          this.imageGalleryLightboxManager = new ImageGalleryLightboxManager();
        }
        const galleryCount = parseInt($('main').attr('data-tour-gallery-count'), 10);
        if (galleryCount > 4) {
          this.initiateHeroImageGalleryGrid();
        } else {
          this.initiateHeroImageGallery();
        }

        this.initiateCustomerPhotos();
        this.initiateReviewsSection();
      });
    });

    byUserInteraction('initiate-instalments-popup', () => {
      import(/* webpackChunkName: "TourInstalmentsPopup" */'@atomic/organisms/tour_b/instalments/instalments-popup').then((module) => {
        const AOTourInstalmentsPopup = module.default;
        const instalmentsPopup = new AOTourInstalmentsPopup();

        instalmentsPopup.initiate();
      });
    });

    initiateBookFlexibilityBanner(TDP_EVENT_CATEGORY);

    if ($(NO_DEPARTURES_NEWSLETTER_SELECTOR).length) {
      const newsletterSignupForm = new AOScoutNewsletterSignupForm(NO_DEPARTURES_NEWSLETTER_SELECTOR, 'TDP_no_dates_form');
      newsletterSignupForm.initiate();
    }

    /* initiate dynamic layout (fixed elements etc.) */
    this.dynamic.initiate();

    byUserInteraction('initiate-common-accordion', () => {
      import(/* webpackChunkName: "AOCommonAccordion" */'@atomic/organisms/_common/accordion').then((module) => {
        const AOCommonAccordion = module.default;
        const accordion = new AOCommonAccordion();
        accordion.initiate();
        byUserInteraction('good-to-know-accordion-collapse', () => {
          accordion.accordions.toggleMultipleAccordions(
            $(ACCORDION_LIST_SELECTOR),
            'collapse',
          );
        });
      });
    });

    import(/* webpackChunkName: "AOScoutAccordion" */'@scout/components/accordion/accordion').then((module) => {
      const AOScoutAccordion = module.default;
      const scoutAccordion = new AOScoutAccordion({ selector: '.js-ao-tour-good-to-know' });
      scoutAccordion.initiate();
    });

    const itinerary = new AOItinerary(
      tourId,
      this.getTourName(),
      TDP_EVENT_CATEGORY,
    );
    itinerary.initiate();

    this.tourPrivateOption = new AOTourPrivateOptionRequest(
      tourId,
      this.getOperatorId(),
    );
    this.tourPrivateOption.initiate();

    const whatsIncluded = new AOWhatsIncluded(
      tourId,
      TDP_EVENT_CATEGORY,
    );
    whatsIncluded.initiate();

    const brochure = new AOTourBrochure(
      tourId,
      this.getTourName(),
      this.getOperatorName(),
      this.getNetRevenue(),
    );
    brochure.initiate();

    const structuredItinerary = new AOStructuredItinerary();
    structuredItinerary.initiate();

    initiateWhereStay(TDP_EVENT_CATEGORY, tourId);

    const faqQuestions = new AOThreadedFaqs(
      tourId,
      MOBILE_WIDTH,
      this.TDP_EVENT_CATEGORY,
    );
    faqQuestions.initiate();
    const faqSearch = new AOFaqSearch(faqQuestions, tourId);
    faqSearch.initiate();

    initiateAskQuestion({
      tourName: this.getTourName(),
      tourId,
      operatorName: this.getOperatorName(),
      onAskQuestionSuccess: (bcpLink, formData) => {
        if (
          !this.hasPrivateOrPersonalizedOption()
          || formData?.booktype !== 'private'
        ) {
          return false;
        }

        const $newsLetterCheckbox = $('.js-ao-common-ask-form').find(
          '.js-aa-checkbox__input',
        );

        if (
          !$newsLetterCheckbox.length
          || $newsLetterCheckbox.prop('checked')
        ) {
          sendGoogleEvent('Newsletter - Signup', 'SignedUp', 'Question');
        }

        window.location.href = bcpLink;
        return true;
      },
    });

    initiateBottomBanner(TDP_EVENT_CATEGORY);

    const visa = new AOVisa(tourId);
    visa.initiate();

    const pdfDownload = new AOPdfDownload(
      this.getTourId(),
      this.getOperatorName(),
      this.getTourName(),
    );
    pdfDownload.initiate();

    setupMapImageBlock(MOBILE_WIDTH, TABLET_WIDTH);

    initiateStartPlanningYourTour(TDP_EVENT_CATEGORY);

    /* read hash part and make the corresponding changes in the layout */
    this.hash.read();

    const snapshotAboveFold = new AOTourAboveFold(
      tourId,
      TDP_EVENT_CATEGORY,
      this.hash.goTo,
    );
    snapshotAboveFold.init();

    adminQuestions.init({ objectType: 'tour', objectId: tourId });

    initiatePlacesYouWillSee(TDP_EVENT_CATEGORY);

    initiateAdventureType(TDP_EVENT_CATEGORY);

    initiateAskForm(TDP_EVENT_CATEGORY);

    // Awards
    initiateAwards(null, TDP_EVENT_CATEGORY, tourId);

    const stickyBar = new AoTourStickyBar(
      TDP_EVENT_CATEGORY,
      [
        $(`.${AvailabilitySection.getAvailabilitySectionClass()}`),
      ],
      this.hash.goTo,
    );
    this.syncChatStickyBarPositions();
    stickyBar.init();

    this.savings();

    if ($('.js-sale-line').length > 0) {
      new Timer(
        $('.js-sale-line .js-ends span'),
        $('.js-sale-line .js-ends').data('ends'),
      ).initiate();
    }

    this.termsAndConditionPopup.initialise();

    initiateAnimalsYouWillSee(TDP_EVENT_CATEGORY);

    const flexibleOptionsPopup = new AOTourFlexibleOptionsPopup(tourId);
    flexibleOptionsPopup.initiate();

    const sustainabiltyPopup = new AOSustainabiltyPopup(null);
    sustainabiltyPopup.initiate();

    if ($(AOTourTravelAgentLoginPrompt.getTriggerSelector()).length) {
      const tdpToBnpPrompt = new AOTourTravelAgentLoginPrompt(tourId);
      tdpToBnpPrompt.init();
    }

    if ($(AOTourTravelAgentShareTour.getTriggerSelector()).length) {
      const shareCoBrandedTDP = new AOTourTravelAgentShareTour({ tourId });
      shareCoBrandedTDP.init();
    }

    if ($(AOTravelAgentContactForm.getTriggerSelector()).length) {
      const travelAgentContactForm = new AOTravelAgentContactForm(tourId);
      travelAgentContactForm.init();
    }

    this.checkAvailabilityButton();
    this.openBrochureDownloadModal();

    const isLiveChatButtonExist = !!document.getElementById('live-chat');
    const common = {
      sendGoogleEvent,
      sendAmplitudeEvent,
      byUserInteraction,
      parameters,
    };
    // eslint-disable-next-line no-unused-vars
    const liveChat = new LiveChat(!isLiveChatButtonExist, common);

    exposeDepartureCardsExperiment();
    exposeTDPNavigationExperiment();
    checkPaxCookies();

    if (document.documentElement.lang === 'en' && $('main').attr('data-eligible-for-structured-itinerary-experiment') === '1') {
      exposeStructuredItineraryExperiment();
    }
  };

  // check if availability button is visible to the user on page load
  this.checkAvailabilityButton = () => {
    const $availabilityButton = $(CHECK_AVAILABILITY_BUTTON_SELECTOR);

    if (!$availabilityButton.length) {
      return;
    }

    const buttonPosition = $availabilityButton.offset().top;
    const buttonHeight = buttonPosition + $availabilityButton.height();
    const viewportPosition = $(window).scrollTop();
    const viewportHeight = viewportPosition + $(window).height();

    const isElementVisible = buttonHeight > viewportPosition && buttonPosition < viewportHeight;

    if (isElementVisible) {
      sendGoogleEvent(
        TDP_EVENT_CATEGORY,
        CHECK_AVAILABILITY_ACTION,
        'Above the Fold',
      );
    }
  };

  // depends on data-block-type attributes in templates
  this.trackedBlockTypes = [
    'Availability',
    'Animals',
    'Places',
    /*
            "Social sharing",
            "Scroll to End of Map Destinations",
            "Scroll to Top of Map Nav links",
            "Scroll to End of Map Nav links",
            "Scroll to End of Map Nav links",
            "Travel Guide",
            "Feedback",
            "About the countries",
            "Awards",
            "CTA",
            "Destinations",
            "Q&As",
            "Guides",
            "Highlights",
            "What's included",
            "Itinerary",
            "Top image",
            "Tour name",
            "Rating top",
            "Locations",
            "Nav",
            "More tours",
            "Breadcrumbs",
            "Tour name",
            "Operator",
            "Policies",
            "Price",
            "Recently viewed",
            "Reviews",
            "Sale Banner",
            "Similar tours",
            "Transport",
            "Trips details",
            "USPs",
            "Videos",
            "Why"
            */
  ];

  this.openBrochureDownloadModal = () => {
    const urlQueryString = new URLSearchParams(document.location.search);
    const isTDP = window.location.pathname.includes('/t/');
    if (isTDP && urlQueryString.has('open_download_brochure')) {
      $(PDF_BROCHURE_DOWNLOAD_BUTTON_SELECTOR).first().click();
    }
  };

  this.initiateHeroImageGallery = () => {
    const heroImageGallery = new HeroImageGallery(
      TDP_EVENT_CATEGORY,
      this.imageGalleryLightboxManager,
    );

    const onFetchCompletion = heroImageGallery.initiate;
    this.fetchTourImageUrls(onFetchCompletion);
  };

  this.initiateHeroImageGalleryGrid = () => {
    this.heroImageGalleryGrid = new HeroImageGalleryGrid(
      TDP_EVENT_CATEGORY,
      this.imageGalleryLightboxManager,
      this.hash.goTo,
      this.initialClickedImageCount,
    );

    const onFetchCompletion = this.heroImageGalleryGrid.initiate;
    this.fetchTourImageUrls(onFetchCompletion);
  };

  this.initiateAvailabilitySection = () => {
    this.availabilitySection = new AvailabilitySection(
      null,
      TDP_EVENT_CATEGORY,
      this.getTourId(),
      this.getOperatorName(),
      this.getTourName(),
    );

    this.availabilitySection.initiate();

    // Use mutation observer to detect any accordion additions to the DOM
    this.setupAccordionMutationObserver();
  };

  // Setup MutationObserver to catch accordions added to DOM
  this.setupAccordionMutationObserver = () => {
    if (typeof MutationObserver !== 'undefined') {
      const observer = new MutationObserver((mutations) => {
        let newAccordionsAdded = false;

        mutations.forEach((mutation) => {
          if (mutation.type === 'childList' && mutation.addedNodes.length) {
            Array.from(mutation.addedNodes).forEach((node) => {
              if (node.nodeType === Node.ELEMENT_NODE) {
                // Check if this node is an accordion
                if (node.classList
                  && (node.classList.contains('js-ao-common-accordion')
                    || node.classList.contains('js-am-tour-availability__variant-installments-accordion'))) {
                  newAccordionsAdded = true;
                  return;
                }

                // Check if this node contains accordions
                if (node.querySelectorAll) {
                  const accordions = node.querySelectorAll('.js-am-tour-availability__variant-installments-accordion');
                  if (accordions.length > 0) {
                    newAccordionsAdded = true;
                  }
                }
              }
            });
          }
        });

        if (newAccordionsAdded) {
          this.initializeAllInstallmentAccordions();
        }
      });

      // Start observing the document body
      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
    }
  };

  this.initiateReviewsSection = () => {
    const reviewsSection = new ReviewsSection(
      TDP_EVENT_CATEGORY,
      this.getTourId(),
      this.imageGalleryLightboxManager,
    );

    reviewsSection.initiate();
  };

  this.processScroll = () => {
    let trackedBlockTypesSelector = '';
    this.trackedBlockTypes.forEach((blockType, index) => {
      if (index > 0) {
        trackedBlockTypesSelector += ', ';
      }

      trackedBlockTypesSelector += `[data-block-type="${blockType}"]`;
    });

    this.scrollEvent(true, null, trackedBlockTypesSelector);

    byWindowAction(['scroll'], () => {
      if (!this.scrollTimeout) {
        const timeAfterLoad = this.timeAfterLoad();

        this.scrollTimeout = setTimeout(() => {
          this.scrollEvent(false, timeAfterLoad, trackedBlockTypesSelector);
          this.scrollToElement(true, timeAfterLoad);

          this.scrollTimeout = null;
        }, 100);
      }
      debounce(this.storeFarthestScrollPos, 400)();
    });
  };

  this.storeFarthestScrollPos = () => {
    const scrollPosPercentage = ((window.pageYOffset + window.innerHeight) / document.body.scrollHeight)
      * 100;
    if (scrollPosPercentage > this.scrollPos) {
      this.scrollPos = scrollPosPercentage.toFixed(0);
    }
  };

  this.timeAfterLoad = () => Date.now() - this.timerStart;

  this.scrollEvent = (initial, timeAfterLoad, trackedBlockTypesSelector) => {
    const timer = timeAfterLoad || this.timeAfterLoad();

    $(trackedBlockTypesSelector).each((index, item) => {
      const $item = $(item);
      if (!$item.height()) {
        return;
      }

      const blockType = $item.data('block-type');
      const isMapPopupOpen = !!$('.mfp-wrap.mfp-ready .js-ao-common-map-popup')
        .length;
      if (
        (isMapPopupOpen && this.mapPopupEventElements.indexOf(blockType) < 0)
        || this.scrollElementList.indexOf(blockType) >= 0
      ) {
        return;
      }

      const isElementVisible = isElementOnScreen(
        $item,
        0,
        'bottom',
      );
      if (!isElementVisible) {
        return;
      }

      this.scrollElementList.push(blockType);

      let label = '';
      if (isMapPopupOpen) {
        label = blockType;
      } else {
        label = `End of ${blockType}`;
      }

      sendGoogleEvent(TDP_EVENT_CATEGORY, 'Scroll', label, {
        nonInteraction: !!initial,
        eventValue: initial ? 0 : timer,
      });
    });
  };

  this.scrollToElement = (initial, timeAfterLoad) => {
    const timer = timeAfterLoad || this.timeAfterLoad();
    const elementScrollCheck = [
      {
        element: $('.ao-tour-availability'),
        blockType: 'Start of Availability',
        checkType: 'top',
      },
    ];

    elementScrollCheck.forEach(({ element, blockType, checkType }) => {
      if (!element.height()) {
        return;
      }

      if (this.scrollElementList.indexOf(blockType) >= 0) {
        return;
      }

      const elementIsVisible = isElementOnScreen(
        element,
        0,
        checkType,
      );

      if (!elementIsVisible) {
        return;
      }

      this.scrollElementList.push(blockType);

      sendGoogleEvent(TDP_EVENT_CATEGORY, 'Scroll', blockType, {
        nonInteraction: !!initial,
        eventValue: initial ? 0 : timer,
        ampEventName: 'section_viewed_tdp_availability',
        has_service_fee: parameters.has_service_fee,
        service_fee: parameters.service_fee,
      });
    });
  };

  const formatPaxCounts = (adults, children) => {
    const adultText = adults === 1 ? 'Adult 1' : `Adults ${adults}`;
    const childText = children === 1 ? 'Child 1' : `Children ${children}`;

    if (adults > 0 && children > 0) {
      return `${adultText} & ${childText}`;
    }
    return adults > 0 ? adultText : childText;
  };

  this.getPaxData = () => {
    const $specificPaxMonth = $('.js-ao-pax-month').first();
    const month = $specificPaxMonth.attr('data-pax-month');
    const year = $specificPaxMonth.attr('data-pax-year');

    const $specificPaxTravelers = $('.js-ao-pax-travelers').first();
    const adults = $specificPaxTravelers.attr('data-pax-adults');
    const children = $specificPaxTravelers.attr('data-pax-children');

    return {
      month,
      year,
      adults,
      children,
    };
  };

  this.checkPaxAvailability = () => {
    const $main = $('main');
    const $checkAvailabilityPaxButton = $(CHECK_AVAILABILITY_PAX_BUTTON_SELECTOR);

    if (!$checkAvailabilityPaxButton.length) {
      return;
    }

    $main.on('click', CHECK_AVAILABILITY_PAX_BUTTON_SELECTOR, (event) => {
      const $button = $(event.currentTarget);

      // 1) Allow the UI to paint immediately before doing heavier work
      requestAnimationFrame(() => {
        // 2) Start smooth scroll *after* the first paint
        requestAnimationFrame(() => {
          const targetEl = document.getElementById('js-ao-tour-availability');
          if (targetEl) {
            targetEl.scrollIntoView({
              behavior: 'smooth',
              block: 'start',
            });
          }

          // 3) Run analytics and data logic off the main click path
          setTimeout(() => {
            const {
              month, year, adults, children,
            } = this.getPaxData();
            const clickSource = $button.attr('data-placement');
            const paxCount = formatPaxCounts(adults, children);

            this.paxAvailabilityPage = 1;

            sendAmplitudeEvent({
              ampEventName: 'tdp_availability_button_clicked',
              selected_date: `${year}-${month}`,
              selected_pax: paxCount,
              click_source: clickSource,
            });

            sendAmplitudeEvent({
              ampEventName: 'section_viewed_tdp_availability',
            });
          }, 0);
        });
      });
    });
  };

  this.eventsInit = () => {
    const $main = $('main');

    $main.on('click', CHECK_AVAILABILITY_BUTTON_SELECTOR, () => {
      sendGoogleEvent(
        TDP_EVENT_CATEGORY,
        'Check Availability Action',
        'Clicked on Check Availability button',
        {
          ampEventName: 'tdp_availability_button_clicked',
          tdp_availability_button_clicked_element: 'Snapshot',
        },
      );
    });

    $main.on('click', SHOW_MORE_PAX_AVAILABILITY_BUTTON, () => {
      const $specificPaxMonth = $('.js-ao-pax-month').first();
      const month = $specificPaxMonth.attr('data-pax-month');
      const year = $specificPaxMonth.attr('data-pax-year');

      const $specificPaxTravelers = $('.js-ao-pax-travelers').first();
      const adults = $specificPaxTravelers.attr('data-pax-adults');
      const children = $specificPaxTravelers.attr('data-pax-children');

      this.paxAvailabilityPage += 1;
      fetchPaxAvailability(month, year, adults, children);
    });

    this.checkPaxAvailability();

    $main.on(
      'click',
      `.${AvailabilitySection.getBookNowButtonClass()}, .${AvailabilitySection.getHoldButtonClass()}, .bn-url`,
      (event) => {
        const GENERATED_CLASS = 'am-tour-availability__variant-cta--book-generated';
        const FROM_CLASS = 'am-tour-availability__variant-cta--book-from';

        event.preventDefault();

        const $target = $(event.currentTarget);
        const price = $target.data('price');

        let label = 'Top';
        const isInAvailabilitySection = !!$target.closest(
          `.${AvailabilitySection.getAvailabilitySectionClass()}`,
        ).length;
        if (isInAvailabilitySection) {
          label = 'Bottom';
        }

        let action;
        if ($target.hasClass(AvailabilitySection.getBookNowButtonClass())) {
          if (isInAvailabilitySection) {
            action = 'Book Now';
          } else {
            action = CHECK_AVAILABILITY_ACTION;
          }
        } else if ($target.hasClass(AvailabilitySection.getHoldButtonClass())) {
          action = '48hr Hold';
        }

        const fields = {
          tourID: this.getTourId(),
          tourOperatorName: this.getOperatorName(),
          pax: 1,
          currencyCode: $('main').data('curr'),
        };

        if (price) {
          fields.formattedTourPrice = price;
          fields.tokenValue = price; // netRevenue
        }

        sendGoogleEvent(TDP_EVENT_CATEGORY, action, label, {
          ...fields,
          ampEventName:
            action === 'Check Availability'
              ? 'section_viewed_tdp_availability'
              : undefined,
        });

        const departureCard = $(event.target.closest('.js-am-tour-availability__variant'));

        sendGoogleEvent(
          TDP_EVENT_CATEGORY,
          'Click through to Book Now',
          action,
          {
            eventValue: parseInt($target.data('variant-id'), 10),
            type_from: 'TDP',
            type_to: 'BNP',
            has_service_fee: parameters.has_service_fee,
            service_fee: parameters.service_fee,
            ampEventName: 'tdp_departure_card_clicked',
            tour_departure_card_clicked_languages: departureCard.find('.js-am-tour-availability__variant-list-item--language').text()?.trim(),
            tour_departure_card_clicked_price: price,
            tour_departure_card_clicked_availability: departureCard.find('.js-am-tour-availability__variant-list-item--seat').text()?.trim() || '',
          },
        );

        if ($target.hasClass(GENERATED_CLASS) || $target.hasClass(FROM_CLASS)) {
          sendGoogleEvent(
            TDP_EVENT_CATEGORY,
            'CTR to BNP',
            $target.hasClass(GENERATED_CLASS) ? 'Loaded Card' : 'From Card',
          );
        }
      },
    );

    $main.on('click', 'nav li', () => {
      sendGoogleEvent(TDP_EVENT_CATEGORY, 'Breadcrumbs', null);
    });

    $main.on(
      'click',
      '.op-wrapper .logo a:first-child, .op-wrapper .name a',
      () => {
        sendGoogleEvent(TDP_EVENT_CATEGORY, 'Operator', null);
      },
    );

    $main.on('click', '.js-ao-tour-similar .txt a:first-child', (e) => {
      sendGoogleEvent(
        TDP_EVENT_CATEGORY,
        'Similar Tours',
        e.target.innerText,
      );
    });

    $main.on('click', '.js-ao-tour-included__trigger-hygieneprotocol', () => {
      window.location.hash = `#${HYGIENE_HASH}`;
      sendGoogleEvent(TDP_EVENT_CATEGORY, 'Hygiene measures', 'Info');
      this.hygieneAction();
    });

    $main
      .on('mouseenter', '.js-ao-tour-included__trigger-personalized', () => {
        $('.js-ao-tour-above-fold__personalized-tooltip').removeClass('hid');
      })
      .on('mouseleave', '.js-ao-tour-included__trigger-personalized', () => {
        $('.js-ao-tour-above-fold__personalized-tooltip').addClass('hid');
      });

    $main.on('click', '.js-ao-tour-included__trigger-flight', () => {
      const $trigger = $('[data-id="flight"]')
        .closest('.js-ao-scout-accordion__bottom')
        .prev();

      this.hash.scroll($trigger);

      if (!$trigger.parent().hasClass('active')) {
        $trigger.click();
      }
    });

    $main.on('mouseover mouseleave', '.js-am-tour-availability__variant-list-item--type', (event) => {
      const $element = $(event.currentTarget);
      const $tooltip = $element.find('.js-am-tour-availability__variant-list-item--type-tooltip');

      if (event.type === 'mouseover') {
        $tooltip.removeClass('hid');
      } else if (event.type === 'mouseout') {
        $tooltip.addClass('hid');
      }
    });

    let lastScrollPosition = null;
    window.addEventListener('visibilitychange', () => {
      if (this.scrollPos !== lastScrollPosition) {
        lastScrollPosition = this.scrollPos;
        sendGoogleEvent(
          TDP_EVENT_CATEGORY,
          'PageExit - scrollPosition',
          this.scrollPos,
          {
            nonInteraction: true,
          },
        );
      }
    });

    $(document).on('tdp:goTo', (_, hash) => {
      this.hash.goTo(hash);
    });
  };

  /* availability functionality */
  this.availability = {
    texts: false,

    loadTexts: (callback) => {
      sendRequest(
        '/api/tour/load',
        {
          action: 'ttip_text',
          id: this.getTourId(),
        },
        (data) => {
          if (data && data.status === 'OK') {
            this.availability.texts = data.texts;
            const availabilityKeys = Object.keys(this.availability.texts);
            for (let i = 0; i < availabilityKeys.length; i += 1) {
              const currentKey = availabilityKeys[i];
              this.availability.texts[currentKey] = this.availability.texts[
                currentKey
              ].replace(/\\/g, '');
            }
            callback();
          }
        },
      );
    },
  };

  this.omnimove = {
    months: (months) => {
      if (!months || !months.length) {
        return;
      }

      const params = [];

      months.forEach((item) => {
        const splitted = item.split('-');
        let month = new Date(Date.parse(`${splitted[0]} 1, 2012`)).getMonth() + 1;
        month = `0${month}`.slice(-2);
        params.push({
          param: 'departure',
          value: `${month}/${splitted[1]}`,
          points: 400,
        });
      });

      setTimeout(() => {
        if (window.tracker) {
          tracker('appendParameters', params);
        }
      }, 5000);
    },
  };

  // Check if the browser is Firefox
  function isFirefox() {
    return typeof InstallTrigger !== 'undefined' || navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
  }

  /* manipulate with hash part of the url */
  this.hash = {
    mapToAnchor: {
      check: AvailabilitySection.getAvailabilitySectionClass(),
      departures: AvailabilitySection.getAvailabilityDeparturesSectionClass(),
      details: 'itn',
      itinerary: 'js-ao-tour-itinerary',
      brochure: 'js-ao-tour-read-later-cta-banner',
      included: 'js-ao-tour-included',
      faqs: 'js-ao-tour-faq',
      operator: 'ao-sustainability-operator',
      reviews: 'rev',
      video: 'js-ao-tour-videos',
      highlights: 'js-ao-tour-highlights',
      transport: 'tr',
      awards: 'js-ao-tour-awards',
      accommodation: 'js-ao-tour-where-stay',
      overview: 'ao-tour-snapshot',
      availability: 'js-ao-tour-availability',
    },

    goTo: (hash, customText, customEvent, offset = 0) => {
      const anchor = this.hash.mapToAnchor[hash];

      window.location.hash = `#${hash}`;

      $('.lazy').removeClass('lazy').addClass('lazyback');

      if (customEvent) {
        sendGoogleEvent(
          TDP_EVENT_CATEGORY,
          customEvent || 'Click',
          customText || hash,
        );
      }

      let $anchorElement = $(`.${anchor}`);
      if ($anchorElement.length === 0) {
        $anchorElement = $(`.js-ao-tour-block.${anchor}`);
      }

      if ($anchorElement.length === 0) {
        $anchorElement = $(`[data-hash="${anchor}"]`);
      }

      if ($anchorElement.length === 0) {
        $anchorElement = $(`[data-hash="${anchor}"]`);
      }

      const anchorDom = $anchorElement[0];
      if ($anchorElement.length > 0) {
        if (typeof window.scrollTo === 'function' && !isFirefox()) {
          const scrollY = window.scrollY + anchorDom.getBoundingClientRect().top - offset;

          window.scrollTo({
            top: scrollY,
            behavior: 'smooth',
          });
        } else {
          this.hash.scroll($anchorElement, 0);
        }
      }

      const $whatsIncludedExpand = $('.js-ao-tour-included .ex');
      if (
        anchor.indexOf('js-ao-tour-included') >= 0
        && $whatsIncludedExpand.length > 0
        && $whatsIncludedExpand.text()
        === $('.js-ao-tour-included__included').data('expand-text')
      ) {
        $whatsIncludedExpand.click();
      }

      // fix availability section overlapping with menu by scrolling 1px
      if (anchor.indexOf('avl') >= 0) {
        window.setTimeout(() => {
          const $window = $(window);

          $window.scrollTop($window.scrollTop() - 1);
        }, 500);
      }

      setTimeout(() => {
        $('.lazyback').removeClass('lazyback').addClass('lazy');
        $('img.lazy, .img.lazy').unveil();
      }, 1500);
    },

    /* read the hash part and do the manipulations */
    read: () => {
      if (window.location.hash.length > 1) {
        const hashes = window.location.hash.substr(1).split(',');

        hashes.forEach((hash) => {
          switch (true) {
            /* Change month in availibility */
            case hash.substr(0, 7) === 'months=': {
              const months = hash.substr(7).split(':');
              this.availabilitySection.selectMonthsByNameArray(months);
              this.availabilitySection.calendarPreselectMonth(months);

              this.omnimove.months(months);
              break;
            }

            /* menu items */
            case hash === 'details':
              if (
                $('.js-ao-tour-itinerary ol .ex').length > 0
                && $('.js-ao-tour-itinerary ol .ex').text()
                === $('.js-ao-tour-itinerary').data('expand-text')
              ) {
                $('.js-ao-tour-itinerary ol .ex').click();
              }
              break;
            case hash === 'included':
              if (
                $('.js-ao-tour-included .ex').length > 0
                && $('.js-ao-tour-included .ex').text()
                === $('.js-ao-tour-included__included').data('expand-text')
              ) {
                $('.js-ao-tour-included .ex').click();
              }
              break;
            case hash === 'highlights':
            case hash === 'itinerary':
            case hash === 'brochure':
            case hash === 'reviews':
            case hash === 'faq':
            case hash === 'ship':
            case hash === 'ships':
            case hash === 'transport':
            case hash === 'transports':
            case hash === 'video':
            case hash === 'awards':
            case hash === 'accommodation':
            case hash === 'overview':
            case hash === 'availability':
            case hash === 'check': {
              const anchor = this.hash.mapToAnchor[hash];

              let $anchor = $(`.${anchor}`);

              if ($anchor.length === 0) {
                $anchor = $(`.js-ao-tour-block.${anchor}`);
              }

              if ($anchor.length > 0) {
                this.hash.scroll($anchor, 0);
              }
              break;
            }

            case hash === HYGIENE_HASH: {
              this.hygieneAction();
              break;
            }

            case hash === 'ask': {
              import(/* webpackChunkName: "AskAQuestion" */'@html/_common/question/script').then((module) => {
                const AskAQuestion = module.default;
                const question = new AskAQuestion();
                question.startEnquiryDialog({
                  id: this.getTourId(),
                  name: this.getTourName(),
                  forceEnquiry: true,
                });
              });
              break;
            }

            case hash === 'private-request': {
              this.tourPrivateOption.loadForm();
              break;
            }
            default:
              break;
          }
        });
      }
    },

    /* scroll to some object */
    scroll: (obj, delay, offset) => {
      const offsetValue = offset || 0;

      if (obj.length > 0) {
        // Read all DOM values BEFORE starting any animations
        const tnbHeight = $('#tnb').length ? $('#tnb').height() : 0;
        const targetOffset = obj.offset().top - tnbHeight - offsetValue;

        setTimeout(() => {
          // Single scroll with pre-calculated offset
          smoothScroll({
            to: targetOffset,
            duration: 50,
          });
        }, delay || 0);
      }
    },
  };

  /* initiate all dynamic elements (fixed positioning, popups, etc) */
  this.dynamic = {
    initiate: () => {
      const $body = $('body');
      this.dynamic.viewportSizeHelpers();

      this.supportScrollIntoView = typeof $body[0].scrollIntoView === 'function';

      this.dynamic.priceBreakdown.initiate();

      /* initiates promotion info breakdown */
      this.dynamic.promotionInfo.initiate();

      /* initiate social buttons */
      this.dynamic.social.initiate();

      this.dynamic.saveTooltip.initiate();

      this.dynamic.map.initiate();

      this.dynamic.saveTourToCookie();

      /* TC tooltip */
      this.dynamic.tc();

      initiateVideos(
        MOBILE_WIDTH,
        this.getTourId(),
        this.getTourName(),
      );

      this.dynamic.operatorTooltip.initiate?.();

      this.dynamic.h1Tooltip.initiate();

      this.dynamic.mapPopup.initiate();

      byWindowAction(
        ['resize'],
        this.dynamic.viewportSizeHelpers.bind(this),
      );
    },

    viewportSizeHelpers: () => {
      this.isMobile = $(window).width() <= MOBILE_WIDTH;
      this.isTablet = !this.isMobile && $(window).width() <= TABLET_WIDTH;
    },

    h1Tooltip: {
      initiated: false,

      initiate: () => {
        const $h1Element = $('main h1');

        $h1Element.click(() => {
          if (!this.dynamic.h1Tooltip.initiated) {
            libInit('tooltip');
          }
        });
      },
    },

    mapPopup: {
      initiate: () => {
        const $body = $('body');

        $body.on(
          'click',
          '.js-ao-tour-tour-information__list .js-ao-tour-tour-information__list-element',
          (event) => {
            const $element = $(event.currentTarget);
            const hash = $element.data('hash');

            $.magnificPopup.close();

            this.hash.goTo(hash, $element.data('event-label'));

            sendGoogleEvent(
              TDP_EVENT_CATEGORY,
              'Map',
              `Nav - ${$element.text().trim()}`,
            );
          },
        );

        $body.on(
          'click',
          '.js-ao-tour-above-fold__price-based-on-text--departure-label',
          () => {
            $.magnificPopup.close();
          },
        );

        $body.on(
          'click',
          '.js-ao-common-map-popup__content-info-details-cta',
          (e) => {
            if (!$(e.target).attr('href')) {
              e.preventDefault();
              $.magnificPopup.close();

              setTimeout(() => {
                this.hash.goTo('check', 'Scroll to Availability', 'Map');
                $(e.target).blur();
              }, 100);
            }

            sendGoogleEvent(TDP_EVENT_CATEGORY, 'Map', 'CTA');
          },
        );
      },
    },

    operatorTooltip: {
      initiated: false,
    },

    tc: () => {
      if ($('.op .tc').length) {
        $('body').one('mouseover', () => {
          if (!$('.op .tc').hasClass('ttip')) {
            $('.op .tc').addClass('ttip');
            libInit('tooltip');
          }
        });
      }
    },

    map: {
      initiated: false,
      locations: false,
      token: false,
      theMap: false,
      static: false,

      initiate: () => {
        $(
          '.js-ao-tour-highlights .map, .js-ao-tour-highlights .js-bl__map-button, .img .pic img.map, .img .st dl.map, .js-map-button',
        ).click((event) => {
          this.dynamic.map.label = '';

          const $target = $(event.currentTarget);
          if ($target.hasClass('js-map-button')) {
            this.dynamic.map.label = 'Open - via Icon';
          } else if (
            $target.closest('.im').length
            || $target.closest('.pic').length
          ) {
            this.dynamic.map.label = 'Open - via Image';
          } else if (
            $target.closest('.st').length
            || $target.closest('.js-ao-tour-highlights')
          ) {
            this.dynamic.map.label = 'Open - via Route Diagram';
          }

          if (event.target.nodeName !== 'A') {
            event.preventDefault();

            const $element = $(event.currentTarget);
            if (this.isMobile && $element.hasClass('bl__map-button')) {
              $element.toggleClass('map-button--loading', true);
            }

            if (!this.dynamic.map.initiated) {
              const requestParams = {
                action: 'locations',
                id: this.getTourId(),
                type: 'tour',
              };

              const priceBreakdown = $(
                '.js-ao-tour-above-fold__price-block',
              ).clone();
              if (priceBreakdown) {
                // This markup is sent to the backend and returned in the map popup where this section is not needed
                priceBreakdown
                  .find('.js-ao-tour-above-fold__action-bar')
                  .remove();
                const priceBreakdownMarkup = priceBreakdown.html();
                requestParams.price_breakdown_markup = priceBreakdownMarkup;
              }

              const $highlightsBlock = $('.js-ao-tour-highlights');
              if ($highlightsBlock.length > 0) {
                requestParams.tour_has_highlights = true;
              }

              sendRequest('/api/tour/load', requestParams, (data) => {
                if (data.component.custom_map_html) {
                  this.dynamic.map.initiated = true;
                  this.dynamic.map.static = data.component.custom_map_html;
                  this.$main.append(data.component.html);
                  this.dynamic.map.showMap(true);
                } else {
                  libInit('dynamicmap_b', () => {
                    this.dynamic.map.initiated = true;
                    this.dynamic.map.locations = data.component.locations;
                    this.dynamic.map.token = data.component.mapbox_key;
                    this.$main.append(data.component.html);
                    this.dynamic.map.showMap(false);
                  });
                }
              });
            } else {
              $('.map_link').click();
            }
          }
        });

        $('body').on(
          'click',
          '#map_popup .js-ao-common-super-popup__header-back, #map_popup .js-ao-common-super-popup__header-close',
          (e) => {
            e.preventDefault();
            $.magnificPopup.close();
          },
        );
      },

      showMap: (customMap) => {
        libInit('popup', () => {
          this.$main.append('<a href="#map_popup" class="hid map_link"></a>');

          if (!customMap) {
            $('#map_popup_map')
              .append(
                '<img src="/im/r/pw/tr-loader-small.gif" class="l">',
              );
          }

          const popupParameters = {
            closeOnBgClick: true,
            showCloseBtn: false,
            mainClass: 'ao-common-popup-wrapper ao-common-super-popup__overlay',
            fixedContentPos: true,
            callbacks: {
              open: () => {
                handleMagnificPopupHistory.openPopup();
                enableBodyScrollLock(
                  $('.mfp-wrap.ao-common-popup-wrapper'),
                );

                if (customMap) {
                  $('#map_popup_map')
                    .addClass('with-custom-map')
                    .html(this.dynamic.map.static);

                  initiateFallbackBackgroundImages();
                } else {
                  this.dynamic.map.gMap('map_popup_map');
                }

                sendGoogleEvent(
                  TDP_EVENT_CATEGORY,
                  'Map',
                  this.dynamic.map.label,
                );
              },

              close: () => {
                disableBodyScrollLock(
                  $('.mfp-wrap.ao-common-popup-wrapper'),
                );

                sendGoogleEvent(TDP_EVENT_CATEGORY, 'Map', 'Close');

                if (!customMap) {
                  this.theMap.off();
                  this.theMap.remove();
                }

                handleMagnificPopupHistory.closePopup();
              },
            },
          };

          const $mapLink = $('.map_link');
          $mapLink.magnificPopup(popupParameters);
          $mapLink.click();

          $('.js-scout-component-map-popup__cta').on('click', () => {
            $.magnificPopup.close();
            // eslint-disable-next-line
            AOAvailabilityDatepicker.scrollToBottomDatePaxSection();
          });
        });
      },

      gMap: (where) => {
        const map = new DynamicMap();
        this.theMap = map.map(where, this.dynamic.map.token);
        map.addLocations(this.dynamic.map.locations);
      },
    },

    priceBreakdown: {
      initiated: false,

      initiate: () => {
        $('.b.val .row a').click((e) => {
          e.preventDefault();

          if (!this.dynamic.priceBreakdown.initiated) {
            this.dynamic.priceBreakdown.initiated = true;

            sendRequest(
              '/api/tour/load',
              {
                action: 'price_breakdown',
                id: this.getTourId(),
              },
              (data) => {
                if (data && data.status === 'OK') {
                  this.$main.append(data.component);

                  $('#breakdown_popup .but')
                    .not('.turq')
                    .click((event) => {
                      if (!$(event.currentTarget).is('.blue')) {
                        event.preventDefault();
                      }

                      $.magnificPopup.close();
                    });

                  libInit('popup', () => {
                    const $breakdownLink = $('.breakdown_link');
                    $breakdownLink.magnificPopup({
                      closeOnBgClick: true,
                      callbacks: {
                        open: () => {
                          sendGoogleEvent(
                            'Price Break Down',
                            'Open',
                            this.getTourName(),
                            { value: this.getSaving().substr(1) },
                          );
                        },
                        close: () => {
                          sendGoogleEvent(
                            'Price Break Down',
                            'Close',
                            this.getTourName(),
                            { value: this.getSaving().substr(1) },
                          );
                        },
                      },
                    });
                    $breakdownLink.click();
                  });

                  /* tooltip (savings) */
                  $('#breakdown_popup .bot li .save').click((event) => {
                    event.preventDefault();
                  });
                  libInit('tooltip', () => {
                  });
                }
              },
            );
          } else {
            $('.breakdown_link').click();
          }
        });
      },
    },

    promotionInfo: {
      initiated: false,

      initiate: () => {
        $('.b.val dl dt.col span, .b.val .pc').click((e) => {
          e.preventDefault();

          if (!this.dynamic.promotionInfo.initiated) {
            this.dynamic.promotionInfo.initiated = true;

            const promotionId = $('.b.val dl dt.col span').data('pid');

            sendRequest(
              '/api/tour/load',
              {
                action: 'get_promotion_data',
                promotion_id: promotionId,
              },
              (data) => {
                if (data && data.status === 'OK') {
                  this.$main.append(data.component);

                  libInit('popup', () => {
                    const $infoLink = $('.p_info_link');
                    $infoLink.magnificPopup({
                      closeOnBgClick: true,
                      callbacks: {
                        open: () => {
                          libInit('popup', () => {
                            $('.p_info_terms_link').magnificPopup({
                              closeOnBgClick: true,
                            });
                          });
                        },
                      },
                    });
                    $infoLink.click();
                  });
                }
              },
            );
          } else {
            $('.p_info_link').click();
          }
        });
      },
    },

    social: {
      initiate: () => {
        this.dynamic.social.send();
        this.dynamic.social.messenger();

        if (this.isMobile || this.isTablet) {
          this.dynamic.social.whatsapp();
        }
      },

      send: () => {
        $('body').on(
          'click',
          '.js-ao-tour-social__list-element--mail',
          (event) => {
            event.preventDefault();
            const $clickedElement = $(event.currentTarget);

            if ($clickedElement.closest('.js-ao-common-map-popup').length) {
              smoothScroll({
                to: $('header'),
                duration: 300,
              });
            }

            let action = '';
            if ($clickedElement.closest('.js-ao-common-map-popup').length) {
              action = 'Open - TDP Map';
            } else {
              action = 'Open - TDP Page';
            }

            if (typeof this.send === 'undefined') {
              import(/* webpackChunkName: "Send" */'@html/_common/send_tour').then((module) => {
                const Send = module.default;
                this.send = new Send();
                this.send.initiate(this.getTourId(), this.getTourName());

                sendGoogleEvent(
                  'Email Tour',
                  action,
                  this.getTourName(),
                );
              });
            } else {
              this.send.initiate(this.getTourId(), this.getTourName());

              sendGoogleEvent('Email Tour', action, this.getTourName());
            }
          },
        );
      },

      whatsapp: () => {
        $('body').on(
          'click',
          '.js-ao-tour-social__list-element--whatsapp',
          (event) => {
            event.preventDefault();

            const shareURL = encodeURIComponent(window.location.href);

            window.location = `whatsapp://send?text=${shareURL}`;

            const $target = $(event.currentTarget);
            let action = '';
            if ($target.closest('.js-ao-common-map-popup').length) {
              action = 'Map';
            } else {
              action = 'Share';
            }

            sendGoogleEvent(
              TDP_EVENT_CATEGORY,
              action,
              'Share - Whatsapp',
              {
                ampEventName: 'share_tour_clicked',
                share_tour_clicked_platform: 'whatsapp',
              },
            );
          },
        );
      },

      messenger: () => {
        $('body').on(
          'click',
          '.js-ao-tour-social__list-element--messenger',
          (event) => {
            event.preventDefault();
            const $target = $(event.currentTarget);

            if (this.isMobile || this.isTablet) {
              const shareUrl = encodeURIComponent(window.location.href);

              window.location = `fb-messenger://share?link=${shareUrl}&app_id=${encodeURIComponent(
                parameters.app_id,
              )}`;
            } else if (
              !this.dynamic.social.initiatedFacebook
              && !this.dynamic.social.initiatingFacebook
            ) {
              this.dynamic.social.initiatingFacebook = true;

              loadJs($target.data('js'), () => {
                FB.init({
                  appId: parameters.app_id,
                  version: 'v2.4',
                });

                this.dynamic.social.initiatedFacebook = true;

                FB.ui(
                  {
                    method: 'send',
                    link: `${window.location.href}`,
                  },
                  () => {
                  },
                );
              });
            } else {
              FB.ui(
                {
                  method: 'send',
                  link: `${window.location.href}`,
                },
                () => {
                },
              );
            }

            let action = '';
            if ($target.closest('.js-ao-common-map-popup').length) {
              action = 'Map';
            } else {
              action = 'Share';
            }

            sendGoogleEvent(
              TDP_EVENT_CATEGORY,
              action,
              'Share - Messenger',
              {
                ampEventName: 'share_tour_clicked',
                share_tour_clicked_platform: 'messenger',
              },
            );
          },
        );
      },
    },

    saveTooltip: {
      initiated: false,
      instInitiated: false,

      initiate: () => {
        if (!this.dynamic.saveTooltip.instInitiated) {
          byUserInteraction('tour-images', () => {
            if (!this.dynamic.saveTooltip.initiated) {
              this.dynamic.saveTooltip.initiated = true;
              libInit('tooltip');
            }

            if (!this.dynamic.saveTooltip.instInitiated) {
              this.dynamic.saveTooltip.instInitiated = true;

              if (!this.availability.texts) {
                this.availability.loadTexts(() => {
                  // this.dynamic.instTooltip();
                });
              } else {
                // this.dynamic.instTooltip();
              }
            }
          });
        } else if (!this.availability.texts) {
          this.availability.loadTexts(() => {
            // this.dynamic.instTooltip();
          });
        } else {
          // this.dynamic.instTooltip();
        }
      },
    },

    /* Save tour to cookie */
    saveTourToCookie: () => {
      let rvTours = null;
      const isBookable = !!this.$main.data('isbookable');
      if (!isBookable) {
        return;
      }
      const tourId = this.getTourId();
      if (getCookie('recently-viewed')) {
        rvTours = JSON.parse(getCookie('recently-viewed'));
        const rvToursIndex = rvTours.indexOf(tourId);
        if (rvToursIndex > -1) {
          rvTours.splice(rvToursIndex, 1);
        }
        rvTours.unshift(tourId);
        rvTours = rvTours.slice(0, 24);
      } else {
        rvTours = [tourId];
      }
      document.cookie = `recently-viewed=${JSON.stringify(
        rvTours,
      )}; max-age=15778463; path=/`;

      byUserInteraction('page-view', () => {
        sendRequest(`/api/central/tours/recently-viewed/${tourId}`);
      });
    },
  };

  this.savings = () => {
    byUserInteraction('tour-savings', () => {
      const tourId = this.getTourId();

      sendRequest('/api/serp/savings', { ids: tourId }, (data) => {
        if (data && data.success) {
          if (data.savings[tourId]) {
            let $addTtip = null;
            if ($(window).width() <= MOBILE_WIDTH) {
              $addTtip = $('.val .ttip.saving:not(.unlock)');
            } else {
              $addTtip = $('.val .ttip.saving');
            }
            $addTtip
              .attr('data-html', data.savings[tourId])
              .attr('data-width', 250)
              .attr('max-width', 250);

            libInit('tooltip');
          }
        }
      });
    });
  };

  this.termsAndConditionPopup = {
    popupLoaded: false,
    htmlData: null,
    tourId: null,

    initialise: () => {
      const $termsConditionsLink = $('.js-policies__terms-conditions');
      this.termsAndConditionPopup.tourId = this.getTourId();

      $termsConditionsLink.on('click', () => {
        this.termsAndConditionPopup.loadCancelationData();
      });
    },

    loadCancelationData: () => {
      if (this.termsAndConditionPopup.popupLoaded) {
        this.termsAndConditionPopup.openPopup(
          this.termsAndConditionPopup.htmlData,
        );
        return;
      }

      sendRequest(
        `/api/book-now/tour_cancellations/${this.termsAndConditionPopup.tourId}`,
        {},
        (data) => {
          if (data.success === true) {
            this.termsAndConditionPopup.popupLoaded = true;
            this.termsAndConditionPopup.htmlData = data.component;
            this.termsAndConditionPopup.openPopup(
              this.termsAndConditionPopup.htmlData,
            );
          }
        },
      );
    },

    openPopup: (html) => {
      libInit('popup', () => {
        $.magnificPopup.open({
          mainClass: 'ao-common-scout-modal__container',
          items: {
            type: 'inline',
            src: html,
            closeOnBgClick: true,
            enableEscapeKey: true,
            showCloseBtn: false,
          },
        });

        if (parameters.is_mobile) {
          $('.ao-common-cancellation-popup__overlay').removeAttr('style');
          $('body').css('overflow', 'hidden');
        }

        this.termsAndConditionPopup.closePopup();
        this.termsAndConditionPopup.handlePolicyLinksClick();
      });
    },

    closePopup: () => {
      $('body').on('click', '.js-ao-common-cancellation-popup__close', () => {
        $.magnificPopup.close();

        if (parameters.is_mobile) {
          $('body').css('overflow', 'unset');
        }
      });
    },

    handlePolicyLinksClick: () => {
      $('body').on(
        'click',
        '.js-ao-common-cancellation-popup__item-link',
        (event) => {
          const policyType = $(event.currentTarget).data('type');
          const policyHeading = $(event.currentTarget).data('heading');
          const $policyContent = $(
            `.js-ao-common-cancellation-popup__policy--${policyType}`,
          );

          $('.js-ao-common-cancellation-popup__heading').text(policyHeading);
          $policyContent.removeClass('hid').siblings().addClass('hid');
          $('.js-ao-common-cancellation-popup__back').removeClass('hid');
          this.termsAndConditionPopup.handleBackButtonClick();
        },
      );
    },

    handleBackButtonClick: () => {
      $('body').on(
        'click',
        '.js-ao-common-cancellation-popup__back',
        (event) => {
          const $content = $('.js-ao-common-cancellation-popup__content');
          $(event.currentTarget).addClass('hid');
          $content.removeClass('hid').siblings().addClass('hid');
          $('.js-ao-common-cancellation-popup__heading').text(
            $content.data('heading'),
          );
        },
      );
    },
  };

  this.fetchTourImageUrls = (onFetchCompletion) => {
    sendRequest(
      '/api/tour/load',
      {
        action: 'images',
        id: this.getTourId(),
      },
      (data) => {
        if (data && data.status === 'OK') {
          onFetchCompletion(this.parseImageUrls(data.component));
        }
      },
    );
  };

  this.parseImageUrls = (imageObjects) => imageObjects.map((imageObject) => (imageObject.source === 'youtube' ? `https://www.youtube.com/embed/${imageObject.embed}` : imageObject.src));

  this.ctaBanners = {
    initiate: () => {
      const elementGAEvent = 'Cta Banners - Click';
      $('.js-ao-tour-read-later-cta-banner__button').click(() => {
        sendGoogleEvent(
          TDP_EVENT_CATEGORY,
          elementGAEvent,
          'Download Brochure',
        );
      });
      $('.js-ao-tour-ask-expert-cta-banner__button').click(() => {
        sendGoogleEvent(
          TDP_EVENT_CATEGORY,
          elementGAEvent,
          'Ask a Travel Expert',
        );
      });
    },
  };

  // [SEARCH-461] https://tourradar.atlassian.net/browse/SEARCH-464
  this.hygieneAction = () => {
    const $trigger = $('[data-id="hygien"]')
      .closest('.js-ao-common-accordion__bottom')
      .prev();

    this.hash.scroll($trigger);

    if (!$trigger.parent().hasClass('ao-common-accordion--active')) {
      $trigger.click();
    }
  };

  this.syncChatStickyBarPositions = () => {
    $(document).on('stickyBar:visibilityChange', (_, isActive) => {
      if (isActive && $('.live-chat-tr-placeholder').length) {
        $('.live-chat-tr-placeholder').css(
          'bottom',
          this.isMobile || this.isTablet ? '90px' : '110px',
        );
        return;
      }
      if ($('.live-chat-tr-placeholder').length) {
        $('.live-chat-tr-placeholder').removeAttr('style');
      }
    });
  };
}
